import React from 'react';
import ProfilePageComponent from '../components/ProfilePage';

const ProfilePage: React.FC = () => {
  return <ProfilePageComponent />;
};

export default ProfilePage;
